/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Descriptions,
  Row,
  Col,
  Form,
  Table,
} from "antd";
import moment from "moment";
import {
  ToolOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import UPMonthsModal from "./UtilityPaymentDetailsMonthsCheck"
const MyDetailsPage = () => {
  const [tableLoading, setTableLoading] = useState(false);
  const [desData, setDesData] = useState({});
  const [tableList, setTableList] = useState([]);
  const [form] = Form.useForm();
  const [isopen, setIsOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const monthList = ['Dec', 'Nov', 'Oct', 'Sep', 'Aug', 'Jul', 'Jun', 'May', 'Apr', 'Mar', 'Feb', 'Jan']

  const monthItemFn = (str, record) => {
    const amount = record?.amount;
    if(!amount) return '$--'
    const paymentColor = record?.paymentColor;
    const paymentDateTemp = record?.paymentDate;
    const paymentDate = paymentDateTemp && moment([paymentDateTemp[0], paymentDateTemp[1] - 1, paymentDateTemp[2]]).format('MM/DD/YYYY') || ""
    
    const colorMatch = {
      0: "#3c8dbc",
      1: "#dd4b39",
      2: "green",
      3: "#f39c12",
    };
    const titleMatch = {
      0: "(Pending)",
      1: "(Not Cash)",
      2: "(Cashed)",
      3: "(Voided)",
    };

    const textColor = colorMatch[paymentColor] || "";
    const title = titleMatch?.[paymentColor] || "";

    return (
       <div
            style={{ color: textColor, cursor: "pointer" }}
            onClick={() => handleCellClick(record)}
          >
            {(title && (
              <span
                style={{
                  borderBottom: `1px dashed ${textColor}`,
                  paddingBottom: "2px",
                }}
              >
                {title}
              </span>
            )) ||
              null}
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {paymentDate
                ? moment(paymentDate).format("MM/DD/YYYY")
                : "-"}
            </span>
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {amount
                ? new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                  }).format(parseFloat(amount))
                : "-"}
            </span>
          </div>
    )
  }

  const getColumnsFn = (month) => {
    return {
      title: month,
      dataIndex: month,
      align: "center",
      width: 100,
      render: (text, record) => {
        const str = `${record.glAcct}&${month}-${record.year}`
        if(record[str]?.length){
          return record[str].map((item, index) => {
            return (
              <div>
                {monthItemFn(str, item)}
                {(record[str].length !==index + 1) && <div style={{ borderBottom: `1px dashed #ccc`, paddingBottom: "2px", margin: '8px 0'}}></div> || null}
              </div>
            )
          })
        }
        return '$--'
      },
    }
  }

  // 定义列，包括输入框
  const initColumns = [
    {
      title: 'Gl Acct',
      align: "center",
      dataIndex: "glAcctName",
      key: "glAcctName",
      hidden: false,
      width: 160,
      fixed: 'left',
      onCell: (record, rowIndex) => {
        return {
          rowSpan: rowIndex % record.rowSpanLength === 0 ? record.rowSpanLength : 0,
        }
      },
      render: (text, record, index) => {
        return record?.glAcct
      },
    },
    {
      title: 'Year',
      align: "center",
      dataIndex: "year",
      key: "year",
      hidden: false,
      width: 100,
      fixed: 'left',
    },
    ...monthList.map(month => getColumnsFn(month))
  ];


  const [columns, setColumns] = useState(initColumns);

  //列表
  const fetchData = async () => {
    setTableLoading(true);
    const vendorUtilPaymentId = new URLSearchParams(window.location.hash.split("?")[1]).get("vendorUtilPaymentId")
    const response = await http.get(api.UtilPaymentCoustomer, { params: {vendorUtilPaymentId}});
    if(response?.code === '1') {
      const data = response.data
      setDesData(data.vendorUtilPayment || {});
  
      let glAcctObj = {}

      Object.entries(data.vendorPayment ?? {}).forEach(([glAcctName, arr]) => {
        arr.forEach(item => {
          const groupKey = `${glAcctName}&${item.month}`;
          (glAcctObj[groupKey] ??= []).push({
            ...item,
            glAcctName,
          });
        });
      });

      let glAcctList = []
      Object.keys(data?.vendorPayment || {})?.forEach((item, index) => {
        (data?.titleYears || []).forEach((year, yearIndex) => {
          const glAcctListIndex = data?.titleYears.length * index + yearIndex
          monthList.forEach(month => {
            const str = `${item}&${month}-${year}`
            glAcctList[glAcctListIndex] = {
              ...glAcctList[glAcctListIndex],
              rowSpanLength: data.titleYears.length,
              glAcct: item,
              year,
              [str]: glAcctObj?.[str] || []
            }
          })
        })
      })
      setTableList(glAcctList);
    }
    setTableLoading(false);
  };

  const handleCellClick = async (record) => {
    setSelectedRecord(record || {});
    setIsOpen(true);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };
 
  useEffect(() => {
    fetchData()
  }, []);

  return (
    <div>
      <Row>
        <Col span={24}>
          <Descriptions
            title={
              <div className="detailTitle">
                <div>
                  <ToolOutlined style={{ marginRight: 8 }} />
                  Utility Payment - View Months
                </div>
              </div>
            }
            bordered
            className="detailMain"
            column={1}
          >
            <Descriptions.Item label="Due Date:">
              {desData?.dueDateStr || ""}
            </Descriptions.Item>

            <Descriptions.Item label="Payment Frequency:">
              {desData?.payFreq || ""}
            </Descriptions.Item>

            <Descriptions.Item label="Service Address:">
              {desData?.serviceAddress || ""}
            </Descriptions.Item>

            <Descriptions.Item label="Meter Number:">
              {desData?.meterNumber || ""}
            </Descriptions.Item>

            <Descriptions.Item label="Pay by Who:">
              {desData?.payBy || ""}
            </Descriptions.Item>
            
          </Descriptions>
        </Col>
      </Row>

      <Table
        rowClassName="table-row-gradient"
        bordered
        loading={tableLoading} // 修正拼写错误
        dataSource={tableList}
        columns={columns}
        pagination={false}
        rowKey="key"
        scroll={{
          x: "max-content",
          y: "calc(100vh - 350px)",
        }}
        style={{
          // border: "1px solid #d9d9d9",
          margin: "20px",
        }}
      />

      <UPMonthsModal
        open={isopen}
        handleCancel={handleCancel}
        form={form}
        record={selectedRecord}
      />
    </div>
  );
};

export default MyDetailsPage;
